export const HIDDEN_PRODUCT_TAG = 'nextjs-frontend-hidden';
export const DEFAULT_OPTION = 'Default Title';
export const SHOPIFY_GRAPHQL_API_ENDPOINT = '/api/2023-01/graphql.json';
export const TAGS = {
  collections: 'collections',
  products: 'products',
  cart: 'cart',
};

export const OPENGRAPH_IMAGE_WIDTH = 1200;
export const OPENGRAPH_IMAGE_HEIGHT = 630;


